<ng-container *permissions="'!Export'">
    <ui-svg-icon
        *ngIf="(weightIsLoading$ | async) === false && creative?.design?.hasHeavyVideo"
        class="indicator"
        uiTooltip="This creative uses a video that is over 2 MB.<br/> It can not be used for display ads, <a href='https://support.bannerflow.com/en/articles/6401112-working-with-heavy-videos' target='_blank'>read more here</a>."
        [icon]="'video-heavy'"
        [uiTooltipHideArrow]="true"
        [uiTooltipInteractive]="true"></ui-svg-icon>
</ng-container>
